export default __webpack_public_path__ + "static/media/white_logo.12a2b7c5.svg";